<template>
    <v-card>
        <v-card-title>
            Rendicontazione Ore
        </v-card-title>
        <v-card-text>

            <v-form v-model="validForm">
                <v-autocomplete label="Risorsa" v-model="dailyWorkResource.resource" :items="resources" item-value="id"
                    :item-text="item => item.name" :disabled="disabledUser" :loading="loading">
                </v-autocomplete>

                <timesheet-calendar :dailyWorkResource="dailyWorkResource" :workLogs="workLogs" @changeDate="changeDate" />
                <v-alert class="mt-4" v-if="message" dismissible type="success">{{ message }}</v-alert>
                <v-alert class="mt-4" v-if="error" dismissible type="success">{{ error }}</v-alert>
            </v-form>
            <v-card class="mt-4 pa-2">
                <v-card-title>
                    Ore su sotto-attività - {{ formatDate(this.form.date) }}
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="dialog = true"><v-icon left>add</v-icon>Aggiungi ore</v-btn>
                </v-card-title>

                <hour-planner-dialog :dialog="dialog" :projects_assigned="projects_assigned" :form="form" @save="save"
                    @update="update" @close-dialog="closeDialog" />
                <v-simple-table height="300px">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Progetto
                                </th>
                                <th class="text-left">
                                    Task
                                </th>
                                <th class="text-left">
                                    Sotto-Task
                                </th>
                                <th class="text-left">
                                    Ore
                                </th>
                                <th class="text-left">
                                    Azioni
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="workLog in workLogs" :key="workLog.id">
                                <td>{{ workLog.subtask.task.project | projectName }}</td>
                                <td>{{ workLog.subtask.task.name }}</td>
                                <td>{{ workLog.subtask.name }}</td>
                                <td>{{ workLog.hours }}</td>
                                <td>
                                    <v-btn icon color="warning" @click="editDialog(workLog)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn icon color="error" @click="deleteWorkLog(workLog.id)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>

        </v-card-text>
    </v-card>


</template>
<script>
import moment from 'moment';
import _ from 'lodash';
import TimesheetCalendar from './TimesheetCalendar.vue';
import HourPlannerDialog from './HourPlannerDialog.vue';

export default {
    name: "HourPlanner",
    props: {
        resources: { type: Array, required: true },
        date: { required: false, default() { return moment().format("YYYY-MM-DD"); } },
        projects: { type: Array, required: true },
    },
    data() {
        let dailyWorkResource = { resource: this.resources && this.resources.length > 0 ? this.resources[0].id : null, date: this.date, reload_calendar: 0 };
        return {
            loading: false,
            validForm: false,
            dailyWorkResource,
            projects_assigned: [],
            error: null,
            message: null,
            workLogs: [],

            form: {
                id: null,
                resource_id: dailyWorkResource.resource,
                project: null,
                project_id: null,
                task_id: null,
                subtask_id: null,
                date: this.date,
                hours: 0
            },
            dialog: false,
        };
    },
    created: function () {
        if (this.dailyWorkResource) {
            this.populateProjectsListResourceAssigned();
            this.getDailyWorkLogs();
        }
    },
    computed: {
        disabledUser() {
            return this.resources.length <= 1;
        },
        formTasks() {
            let selectedProject = this.projects_assigned.find(
                project => project.id === this.form.project_id
            );

            return selectedProject ? selectedProject.tasks : [];
        },
        formSubtasks() {
            let selectedProject = this.projects_assigned.find(
                project => project.id === this.form.project_id
            );

            if (selectedProject) {
                let selectedTask = selectedProject.tasks.find(
                    task => task.id === this.form.task_id
                );

                return selectedTask ? selectedTask.sub_tasks : [];
            }

            return [];
        },
    },
    methods: {
        populateProjectsListResourceAssigned() {
            this.loading = true;
            this.error = null;
            this.list = [];

            if (!isNaN(this.dailyWorkResource.resource)) {
                axios.get("/resources/" + this.dailyWorkResource.resource + "/assignedProjects")
                    .then((response) => {
                        if (response.data.result === "ok") {
                            this.projects_assigned = response.data.projects;
                        }
                    })
                    .catch((error) => {
                        this.error = error;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
            else {
                this.projects_assigned = [];
                this.projects_assigned.push({ id: null, title: "Altro", customer: null });
            }

        },
        getDailyWorkLogs() {
            this.loading = true;
            this.error = null;
            this.workLogs = [];

            axios.post("/WorkLog/getDaily", {
                resource_id: this.dailyWorkResource.resource,
                date: this.dailyWorkResource.date
            })
                .then((response) => {
                    if (response.data.result === "ok") {
                        this.workLogs = response.data.workLogs;
                    }
                })
                .catch((error) => {
                    this.error = error;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        changeDate(value) {
            this.form.date = value;
        },
        editDialog(workLog) {
            this.form.id = workLog.id;
            this.form.project = workLog.subtask.task.project;
            this.form.project_id = workLog.subtask.task.project.id;
            this.form.task_id = workLog.subtask.task.id;
            this.form.subtask_id = workLog.subtask_id;
            this.form.hours = workLog.hours;

            this.dialog = true;
        },
        formatDate(dateString) {
            let date = new Date(dateString);

            let options = {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            };
            return date.toLocaleDateString('it-IT', options);
        },
        save(value) {
            this.loading = true;
            this.error = null;
            this.message = null;
            this.dialog = false;

            Object.assign(this.form, value);

            axios.post("/WorkLog", this.form)
                .then((response) => {
                    if (response.data.result === "ok") {
                        this.message = response.data.result === "ok" ? "Salvataggio avvenuto con successo" : null;
                        this.getDailyWorkLogs();

                        this.resetForm();
                    }
                })
                .catch((error) => {
                    this.error = error;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        update(value) {
            this.loading = true;
            this.error = null;
            this.message = null;
            this.dialog = false;

            Object.assign(this.form, value);

            axios.put(`/WorkLog/${this.form.id}`, this.form)
                .then((response) => {
                    if (response.data.result === "ok") {
                        this.message = response.data.result === "ok" ? "Aggiornamento avvenuto con successo" : null;
                        this.getDailyWorkLogs();

                        this.resetForm();
                    }
                })
                .catch((error) => {
                    this.error = error;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteWorkLog(id) {
            this.loading = true;
            this.error = null;
            this.message = null;
            this.dialog = false;

            axios.delete(`/WorkLog/${id}`)
                .then((response) => {
                    if (response.data.result === 'ok') {
                        this.message = response.data.result === "ok" ? "Eliminazione avvenuta con successo" : null;
                        this.getDailyWorkLogs();

                        this.resetForm();
                    }
                })
                .catch((error) => {
                    this.error = error;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            this.resetForm();
            this.dialog = false;
        },
        resetForm() {
            this.form.id = null;
            this.form.project_id = null;
            this.form.task_id = null;
            this.form.subtask_id = null;
            this.form.hours = 0;
        },
        isValidDate(date) {
            return (/^\d{4}-\d{2}-\d{2}$/.test(date) && !isNaN(Date.parse(date.trim())));
        },
    },
    watch: {
        'dailyWorkResource.date': function () {
            if (this.isValidDate(this.dailyWorkResource.date)) {
                this.getDailyWorkLogs();
            }
        },
        'dailyWorkResource.resource': function () {
            if (this.dailyWorkResource.resource) {
                this.populateProjectsListResourceAssigned();
                this.form.resource_id = this.dailyWorkResource.resource;
                this.getDailyWorkLogs();
            }
        },
    },
    filters: {
        projectName: function(item) {
            let jobCode = ( item?.customer?.code && item?.code) ? item.customer.code + '.' + item.code + " ": '';
            console.log(item);
            return jobCode + item?.name;
        }
    },
    components: {
        TimesheetCalendar,
        HourPlannerDialog
    }
}
</script>
